export const toFiniteNumber = (value: unknown): number | null => {
  const parsed = typeof value === 'number' ? value : Number.parseFloat(String(value ?? ''));
  return Number.isFinite(parsed) ? parsed : null;
};

export const normalizePatientHeightCm = (value: unknown): number | null => {
  const parsed = toFiniteNumber(value);
  if (parsed == null || parsed <= 0) return null;

  // Some records are stored in meters (e.g. 1.5) even though the field is patientHeightCm.
  if (parsed < 10) {
    return Number((parsed * 100).toFixed(1));
  }

  return parsed;
};

export const normalizePatientWeightKg = (value: unknown): number | null => {
  const parsed = toFiniteNumber(value);
  if (parsed == null || parsed <= 0) return null;
  return Number(parsed.toFixed(1));
};
